import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getAlerts } from '../services/alerts';
import usePagination from './usePagination';

const id = 'alerts';

export const useAlerts = (patient, group, ack_pending) => {
    const {
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count,
        currentToken,
        resolveHeader
    } = usePagination();

    const { isPending, isError, data } = useQuery({
        queryKey: [id, { paginationModel, patient, group, ack_pending }],
        queryFn: () =>
            getAlerts({
                pageLimit: paginationModel.pageSize,
                pageToken: currentToken(paginationModel.page),
                patient,
                group,
                ack_pending
            })
    });

    useEffect(() => {
        if (data) {
            resolveHeader(data.headers, paginationModel.page);
        }
    }, [data]);

    return {
        data: data?.data || [],
        isLoading: isPending,
        error: isError,
        count,
        rowsPerPageOptions,
        paginationModel,
        setPaginationModel
    };
};
